import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";

const TermsPage = () => {
  const hero = (
    <PageHero
      eyebrow="Yasal"
      title="Kullanım Şartları"
      subtitle="Verasist platformunu kullanmadan önce lütfen bu şartları dikkatlice okuyun. Platformu kullanarak bu şartları kabul etmiş sayılırsınız."
    />
  );

  const Content = ({ children }) => (
    <section className="py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-10 text-[14.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.88 }}>
          {children}
        </div>
      </div>
    </section>
  );

  const H2 = ({ children }) => <h2 className="text-[20px] font-bold" style={{ color: "var(--fg)" }}>{children}</h2>;
  const P = ({ children }) => <p>{children}</p>;
  const Ul = ({ children }) => <ul className="space-y-2 list-disc pl-5">{children}</ul>;
  const Li = ({ children }) => <li>{children}</li>;

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/blog/cybersecurity.jpg" alt="Kullanım şartları" height="280px" />
      <SectionReveal>
        <Content>
          <div>
            <H2>1. Genel Hükümler</H2>
            <P>Bu Kullanım Şartları ("Şartlar"), Verasist Yazılım A.Ş. ("Verasist") ile platform kullanıcısı ("Kullanıcı" veya "siz") arasındaki hukuki bağlayıcı sözleşmeyi oluşturur. Platforma erişerek veya platformu kullanarak bu Şartları kabul etmiş olursunuz.</P>
          </div>

          <div>
            <H2>2. Hizmet Tanımı</H2>
            <P>Verasist, işletmelere yapay zeka destekli sesli ajan çözümleri sunan bir SaaS platformudur. Hizmet kapsamında:</P>
            <Ul>
              <Li>Sesli AI ajan oluşturma ve yönetme</Li>
              <Li>STT (Speech-to-Text), LLM ve TTS (Text-to-Speech) pipeline yönetimi</Li>
              <Li>Telefon santrali ve CRM entegrasyonları</Li>
              <Li>Çağrı transkript, özet ve analitik raporları</Li>
              <Li>API ve SDK erişimi (plana bağlı olarak)</Li>
            </Ul>
          </div>

          <div>
            <H2>3. Hesap ve Güvenlik</H2>
            <Ul>
              <Li>18 yaşından büyük ve yasal olarak sözleşme yapma ehliyetine sahip olmalısınız.</Li>
              <Li>Hesap bilgilerinizin gizliliğinden siz sorumlusunuz.</Li>
              <Li>Hesabınız üzerinden gerçekleşen tüm faaliyetlerden siz sorumlusunuz.</Li>
              <Li>Yetkisiz kullanım durumunda derhal bize bildirmelisiniz.</Li>
            </Ul>
          </div>

          <div>
            <H2>4. Kullanım Kısıtlamaları</H2>
            <P>Aşağıdaki kullanımlar kesinlikle yasaktır:</P>
            <Ul>
              <Li>Yasadışı, taciz edici, tehditkar veya zararlı amaçlarla kullanım</Li>
              <Li>Platformu tersine mühendislik, kaynak kodunu çıkarma veya kopyalama</Li>
              <Li>Başkalarının fikri mülkiyet haklarını ihlal eden içerikler</Li>
              <Li>Otomatik arama (robocall) veya spam amaçlı kullanım</Li>
              <Li>Platformun normal çalışmasını engelleyecek veya aşırı yükleyecek faaliyetler</Li>
            </Ul>
          </div>

          <div>
            <H2>5. Fiyatlandırma ve Ödeme</H2>
            <Ul>
              <Li>Ücretlendirme, seçtiğiniz plana ve aylık görüşme dakikasına göre belirlenir.</Li>
              <Li>Faturalar aylık veya yıllık olarak kesilir (seçtiğiniz döneme göre).</Li>
              <Li>Ödemeler fatura tarihinden itibaren 14 gün içinde yapılmalıdır.</Li>
              <Li>Gecikmiş ödemelerde hizmet askıya alınabilir.</Li>
              <Li>Fiyatlar önceden bildirilmek kaydıyla değiştirilebilir.</Li>
            </Ul>
          </div>

          <div>
            <H2>6. Fikri Mülkiyet</H2>
            <P>Platform, yazılım, tasarım, logo ve tüm içerik Verasist'in fikri mülkiyetidir. Kullanıcı, platformu yalnızca bu Şartlar çerçevesinde kullanma hakkına sahiptir. Kullanıcı tarafından oluşturulan içerikler (ajan senaryoları, ses profilleri vb.) kullanıcıya aittir.</P>
          </div>

          <div>
            <H2>7. Sorumluluk Sınırlaması</H2>
            <P>Verasist, platformun kesintisiz veya hatasız çalışacağını garanti etmez. Hizmet "olduğu gibi" sunulur. Verasist, platform kullanımından doğabilecek dolaylı, arızi veya sonuç olarak ortaya çıkan zararlardan sorumlu değildir. Verasist'in toplam sorumluluğu, son 12 ayda ödediğiniz ücret tutarını aşamaz.</P>
          </div>

          <div>
            <H2>8. Sözleşmenin Sona Ermesi</H2>
            <P>Taraflardan biri 30 gün önceden yazılı bildirimde bulunarak sözleşmeyi feshedebilir. Şartların ihlali durumunda Verasist, derhal hesabı askıya alma veya sonlandırma hakkını saklı tutar.</P>
          </div>

          <div>
            <H2>9. Uyuşmazlık Çözümü</H2>
            <P>Bu Şartlar Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda İstanbul Merkez (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.</P>
          </div>

          <div>
            <H2>10. İletişim</H2>
            <P>Sorularınız için: <a href="mailto:info@verasist.ai" style={{ color: "var(--brand-cyan)" }}>info@verasist.ai</a></P>
            <P className="mt-2 text-[13px]" style={{ opacity: 0.7 }}>Son güncelleme: 1 Temmuz 2026</P>
          </div>
        </Content>
      </SectionReveal>
    </PageLayout>
  );
};

export default TermsPage;
